/* @ngInject */
function HomeController ($scope, $rootScope, $timeout, $location, $q, $translate, $state, $stateParams, TasksService, BoardsService, ModalService, ToastService, BriefingService, ViewOptionService, UdsModalService, WorkflowService, WorkflowHeaderService, LocalStorageService, ApprovalsService) {
  const getBoardFormDialogController = () => import('../../dialogs/board-form/board-form-dialog.controller')
  const getRequestDetailsDialogController = () => $q.when(import('../../dialogs/request-details/request-details-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))
  const getNewTaskDialogController = () => $q.when(import('../../dialogs/new-task/new-task-dialog.controller'))
  const getRequestFormDialogController = () => $q.when(import('../../dialogs/request-form/request-form-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../dialogs/subtask-details/subtask-details-dialog.controller'))
  const getCreateTaskDialogController = () => $q.when(import('../../dialogs/create-task/create-task-dialog.controller'))

  $scope.flags = {
    loading: true,
    loadingInsights: true,
    hasBriefings: false,
    isSearching: false,
    isFiltering: false
  }

  $scope.companyFeatures = {
    boardsLimit: null,
    boardsLimitReached: false
  }

  $scope.workflowTitle = ''
  $scope.selectedTab = ''
  $scope.tabsCounts = {
    allTasks: 0,
    requests: 0,
    myApprovals: 0,
    boards: 0
  }
  $scope.searchFilter = {
    items: [],
    count: 0
  }
  $scope.showBackButton = false

  let search
  let filters

  const api = {
    getBoardFormDialogController,
    getRequestDetailsDialogController,
    getUpgradeCompanyPlanDialogController,
    getNewTaskDialogController,
    getRequestFormDialogController,
    getSubtaskDetailsDialogController,
    getCreateTaskDialogController,
    _reloadBoards,
    _getTabsCounts,
    _getBoards,
    _getTasksSearchFilter,
    _resetTabObject,
    _resetSearchFilterObject,
    _openRequestDetailDialog,
    _openNewRequestDialog,
    _openCreateTaskDialog,
    _countCompanyBriefings,
    _validateCompanyFeatures,
    _openUpgradeCompanyPlanDialog,
    _getPricingTooltip,
    _openNewTask,
    _onSuccessOpenNewTask,
    _goToBriefingsPage,
    _setHeader,
    _addNewBoard,
    _clearSearchAndFilters,
    _getInsights,
    _openSubtaskDetailDialog,
    _goToCalendarPage,
    _onSearchFilter
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._resetTabObject('boards')
    api._resetSearchFilterObject(true, false)
    const params = $location.search()
    const isUserSysAdminAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const paramTab = $stateParams?.tab || null

    if ($stateParams.filter) {
      $scope.defaultFilter = $stateParams.filter
    }

    if (params.createRequest && isUserSysAdminAdminDesigner) {
      api._openNewTask()
    } else if (params.subtask) {
      api._openSubtaskDetailDialog(params.subtask)
    } else if (params.request) {
      api._openRequestDetailDialog(params.request)
    }

    $q.all([
      api._getTabsCounts(),
      api._countCompanyBriefings()
    ]).then(() => {
      $scope.flags.loading = false

      let selectedTab = paramTab || LocalStorageService.get('workflow-home-tab-selected')
      if (!selectedTab) {
        selectedTab = 'allTasks'
      }
      $scope.handleTabChange({ detail: { selected: selectedTab } }, true)
      $timeout(() => {
        $(`.workflow-home-page uds-tab[name="${selectedTab}"]`).attr('selected', true)
      }, 150)
    })

    api._getInsights()
    api._validateCompanyFeatures()
  }

  $translate.onReady(() => {
    $scope.searchResultsSortOptions = [
      {
        label: $translate.instant('recents'),
        value: 'createdAt',
        active: true
      },
      {
        label: $translate.instant('deliveryDate'),
        value: 'deliveryForecast'
      },
      {
        label: $translate.instant('title'),
        value: 'title'
      },
      {
        label: $translate.instant('status'),
        value: 'status'
      }
    ]

    $rootScope.getUser().then(user => {
      $scope.workflowTitle = `${$translate.instant('hello')},  ${user.name}`
    })
  })

  const deregisterWorkflowEditedBoard = $scope.$on('workflow.editedBoard', api._reloadBoards)
  const deregisterWorkflowRemovedBoard = $scope.$on('workflow.removedBoard', api._reloadBoards)

  const deregisterOpenRequestDetailsDialog = $scope.$on('workflow.home.openRequestDetailsDialog', ($event, { taskId }) => {
    api._openRequestDetailDialog(taskId)
  })
  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    api._openCreateTaskDialog(data?.createMore)
  })

  $scope.$on('$destroy', () => {
    deregisterWorkflowEditedBoard()
    deregisterWorkflowRemovedBoard()
    deregisterOpenRequestDetailsDialog()
    deregisterReopenCreateTaskDialog()
  })

  $scope.isInsightsEmpty = () => {
    return !$scope.flags.loadingInsights && $scope.insights.total === 0
  }

  $scope.getViewModeForSearchedTask = (task) => {
    const statusToBeARequest = ['WAITING_USER_ADJUST', 'WAITING_RESPONSE']
    if (statusToBeARequest.includes(task.status)) return 'REQUEST'
    return 'TASK'
  }

  $scope.getAvailableBoardsCountTranslate = (boardsLimit) => {
    const plural = $translate.instant('availablePlural')
    const singular = $translate.instant('available')
    const boardsAvailable = boardsLimit > 1 ? plural : singular

    return `${boardsLimit} ${boardsAvailable}`
  }

  $scope.handleTabChange = async (event, isInitial = false) => {
    if (!isInitial) {
      $scope.defaultFilter = null
    }

    $scope.flags.isFiltering = false

    if (event.detail.selected && event.detail.selected !== $scope.selectedTab) {
      $scope.selectedTab = event.detail.selected
    }

    LocalStorageService.set('workflow-home-tab-selected', $scope.selectedTab)

    if ($scope.selectedTab === 'boards') {
      api._resetTabObject('boards')
      api._getBoards()
    }
  }

  $scope.openBoard = function (board) {
    const viewOption = ViewOptionService.get(board.id)
    ViewOptionService.setSearchView(viewOption)

    $scope.$emit('headerSearch.clearText')
    $location.path(`/workflow/${viewOption}`).search({ board: board.id })
  }

  $scope.openBoardFormDialog = function () {
    getBoardFormDialogController().then(({ BoardFormDialogController }) => {
      const boardFormDialog = UdsModalService.createModal({
        controller: BoardFormDialogController,
        modalName: 'boardFormDialog',
        onClose: (didUpdate) => {
          if (didUpdate) {
            api._reloadBoards()
          }
        }
      })

      boardFormDialog.open()
    })
  }

  $scope.onChangeSortOrder = (tab) => {
    const sort = $scope[tab].$sort
    const order = $scope[tab].$order === 'ASC' ? 'DESC' : 'ASC'

    if (tab === 'searchFilter') {
      api._resetSearchFilterObject(false, true)
    } else {
      api._resetTabObject(tab, true)
    }
    $scope[tab].$sort = sort
    $scope[tab].$order = order

    if (tab === 'searchFilter') {
      api._getTasksSearchFilter().finally(() => {
        $timeout(() => { $scope.searchFilter.loading = false })
      })
    }
  }

  $scope.onChangeSortSelect = (event, tab) => {
    event.preventDefault()
    event.stopPropagation()
    const value = event?.detail?.value

    if (value && tab) {
      if (tab === 'searchFilter') {
        api._resetSearchFilterObject(false, true)
      } else {
        api._resetTabObject(tab, true)
      }

      $scope[tab].$sort = value

      if (tab === 'searchFilter') {
        api._getTasksSearchFilter().finally(() => {
          $timeout(() => { $scope.searchFilter.loading = false })
        })
      }
    }
  }

  $scope.openRequestDetails = function (requestId) {
    api._openRequestDetailDialog(requestId)
  }

  $scope.goToWorkflowAnalytics = () => {
    $state.go('analytics.dashboard', {
      slug: 'workflow-overview'
    })
  }

  $scope.percentage = function (number) {
    return `${parseInt(number * 100, 10)}%`
  }

  $scope.emptySearchResultBackButton = {
    icon: 'arrow-left',
    text: 'goBack',
    type: 'secondary',
    click: api._clearSearchAndFilters
  }

  $scope.loadMoreTasksSearchFilter = async () => {
    $scope.searchFilter.loadingMore = true
    $scope.searchFilter.$skip = $scope.searchFilter.$skip + $scope.searchFilter.$top
    api._getTasksSearchFilter().finally(() => {
      $timeout(() => { $scope.searchFilter.loadingMore = false })
    })
  }

  $scope.getPeriodBefore = (periodStart) => {
    const date = new Date(periodStart)
    date.setDate(date.getDate() - 30)
    return date
  }

  $scope.filterData = function (cardFilter) {
    $scope.searchFilter = {
      loadingMore: false,
      loading: true,
      items: [],
      count: 0,
      $top: 10,
      $skip: 0
    }

    const today = new Date()
    const todayFormatted = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 3, 0, 0, 0)
    const dateThirtyDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30, 3, 0, 0, 0)

    switch (cardFilter) {
      case 'activeTasks':
        filters = {
          ...filters,
          isArchived: false,
          taskStatus: 'INBOX,PROGRESS,REVIEW,WAITING_ADM_ADJUST',
          createdAtStart: dateThirtyDaysAgo.toISOString(),
          createdAtEnd: todayFormatted.toISOString()
        }

        break
      case 'deliveryDateToday':
        filters = {
          ...filters,
          isArchived: false,
          taskStatus: 'INBOX,PROGRESS,REVIEW,WAITING_ADM_ADJUST',
          deliveryDateStart: todayFormatted.toISOString(),
          deliveryDateEnd: todayFormatted.toISOString(),
          createdAtStart: dateThirtyDaysAgo.toISOString(),
          createdAtEnd: todayFormatted.toISOString()
        }
        break
      case 'overdueTasks': {
        const dateOneDayAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 3, 0, 0, 0)

        filters = {
          ...filters,
          isArchived: false,
          taskStatus: 'INBOX,PROGRESS,REVIEW,WAITING_ADM_ADJUST',
          deliveryDateStart: dateThirtyDaysAgo.toISOString(),
          deliveryDateEnd: dateOneDayAgo.toISOString(),
          createdAtStart: dateThirtyDaysAgo.toISOString(),
          createdAtEnd: todayFormatted.toISOString()
        }
        break
      }
      case 'overdueSlaTasks': {
        filters = {
          ...filters,
          daysInStage: 'exceeded',
          isArchived: false,
          taskStatus: 'INBOX,PROGRESS,REVIEW,WAITING_ADM_ADJUST',
          createdAtStart: dateThirtyDaysAgo.toISOString(),
          createdAtEnd: todayFormatted.toISOString()
        }
        break
      }
    }

    api._getTasksSearchFilter().finally(() => {
      $timeout(() => {
        $scope.showBackButton = true
        $scope.searchFilter.loading = false
        $scope.flags.isSearching = true

        $scope.headerToolbar = {
          search: {
            onSearch: (searchTerm) => {
              search = searchTerm

              if (!searchTerm && !filters) {
                $scope.flags.isSearching = false
                $scope.searchFilter = {
                  items: [],
                  count: 0
                }
                search = undefined
                return
              }

              $scope.flags.isSearching = true
              api._resetSearchFilterObject(false, true)
              api._getTasksSearchFilter().finally(() => {
                $scope.searchFilter.loading = false
              })
            }
          }
        }
      }, 100)
    })
  }

  function _clearSearchAndFilters () {
    $scope.$broadcast('advancedSearch.clearAllFilters')
    $scope.$broadcast('advancedSearch.clearSearch')
  }

  $scope.backPage = () => {
    $scope.$broadcast('advancedSearch.clearAllFilters')
    $scope.$broadcast('advancedSearch.clearSearch')
    api._setHeader()
  }

  function _validateCompanyFeatures () {
    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      if (features['WORKFLOW.MAX_BOARDS']) {
        $scope.companyFeatures.boardsLimit = features['WORKFLOW.MAX_BOARDS'].limit
      }

      api._getPricingTooltip()
    })

    $rootScope.getCompanyFeatures().then(api._setHeader)
  }

  function _getPricingTooltip () {
    const planId = $rootScope.companyFeaturesAndAddons.id

    if (planId === 1) {
      $scope.maxBoardsTooltip = $translate.instant('billingTooltips.maxBoardsLimitPro')
    } else if (planId === 2) {
      $scope.maxBoardsTooltip = $translate.instant('billingTooltips.maxBoardsLimitEnterprise')
    }

    return $scope.maxBoardsTooltip
  }

  function _openUpgradeCompanyPlanDialog (modalData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: modalData
      })

      upgradeCompanyPlanDialog.open()
    })
  }

  function _getInsights () {
    $scope.flags.loadingInsights = true
    $scope.periodStart = filters?.createdAt ? filters.createdAt : new Date().toISOString()
    WorkflowService.getWorkflowHomeInsights($scope.periodStart).then(insights => {
      $scope.insights = insights
    }).finally(() => {
      $scope.flags.loadingInsights = false
    })
  }

  function _reloadBoards () {
    api._getTabsCounts()

    if ($scope.selectedTab === 'boards') {
      api._resetTabObject('boards')
      api._getBoards()
    }
  }

  function _addNewBoard () {
    if ($scope.companyFeatures.boardsLimitReached) {
      api._openUpgradeCompanyPlanDialog({
        featureName: $translate.instant('billingFeatures.workflowMaxBoards'),
        featureSlug: 'WORKFLOW.MAX_BOARDS'
      })
    } else {
      $scope.openBoardFormDialog()
    }
  }

  function _getTasksSearchFilter () {
    let showAll = true

    if (filters?.isArchived !== null && filters?.isArchived !== undefined) {
      showAll = false
    }

    const options = { ...filters, search, $skip: $scope.searchFilter.$skip, $top: $scope.searchFilter.$top, $sort: $scope.searchFilter.$sort, $order: $scope.searchFilter.$order, showAll }
    return TasksService.getTasks(options).then(result => {
      $scope.searchFilter.items.push(...result.rows)
      $scope.searchFilter.count = result.count
    })
  }

  async function _getTabsCounts () {
    return WorkflowService.getWorkflowHomeTabsCounts().then(tabsCounts => {
      $scope.companyFeatures.boardsLimitReached = ($scope.companyFeatures.boardsLimit != null && tabsCounts.boards >= $scope.companyFeatures.boardsLimit)
      $scope.tabsCounts = tabsCounts
    })
  }

  function _getBoards () {
    $scope.boards.loading = true
    return BoardsService.getBoards().then(result => {
      $scope.boards.items.push(...result.rows)
      $scope.boards.count = result.count
      $scope.boards.loading = false
    })
  }

  function _resetSearchFilterObject (resetSorting = false, loading = false) {
    $scope.searchFilter.loading = loading
    $scope.searchFilter.loadingMore = false
    $scope.searchFilter.items = []
    $scope.searchFilter.count = 0
    $scope.searchFilter.$top = 10
    $scope.searchFilter.$skip = 0

    if (resetSorting) {
      $scope.searchFilter.$sort = 'createdAt'
      $scope.searchFilter.$order = 'DESC'
    }
  }

  function _resetTabObject (scopeObjectKey, loading = false) {
    $scope[scopeObjectKey] = {
      loading: loading,
      loadingMore: false,
      items: [],
      count: null,
      $top: 10,
      $skip: 0
    }
  }

  function _openSubtaskDetailDialog (id) {
    TasksService.getTaskById(id).then((subtask) => {
      api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: SubtaskDetailsDialogController,
          modalName: 'subtaskDetailsDialog',
          data: {
            subtask: subtask
          }
        })

        modal.open()
      })
    })
  }

  function _openRequestDetailDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        }
      })
      modal.open()
    })
  }

  function _countCompanyBriefings () {
    return BriefingService.countCompanyBriefings('WORKFLOW').then(count => {
      $scope.flags.hasBriefings = count > 0
    })
  }

  function _openNewTask () {
    api.getNewTaskDialogController().then(({ NewTaskDialogController }) => {
      ModalService.showModal({
        templateId: 'newTask.html',
        templateUrl: '/workflow/dialogs/new-task/new-task-dialog.html?$$REVISION$$',
        controller: NewTaskDialogController,
        destroyable: true,
        observeChanges: true
      }).then(api._onSuccessOpenNewTask)
    })
  }

  function _openNewRequestDialog (isRequestWithUser) {
    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          requestWithUser: isRequestWithUser,
          location: 'home'
        }
      })
    })
  }

  function _openCreateTaskDialog (createMore = false) {
    api.getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        data: { createMore }
      })

      modal.open()
    })
  }

  function _onSuccessOpenNewTask (created) {
    $location.search({ createRequest: null })

    if (created) {
      api._getTabsCounts()
    }
  }

  function _goToBriefingsPage () {
    $state.go('workflow.briefings')
  }

  function _goToCalendarPage () {
    $state.go('marketingCalendar')
  }

  function _onSearchFilter (selectedFilters) {
    filters = {
      taskStatus: selectedFilters?.status || [],
      taskTypes: selectedFilters?.type || [],
      taskTags: selectedFilters?.tags || [],
      assignees: selectedFilters?.assignees || [],
      priorities: selectedFilters?.priorities || [],
      authors: selectedFilters?.authors || [],
      deliveryDateStart: selectedFilters?.deliveryDateStart,
      deliveryDateEnd: selectedFilters?.deliveryDateEnd,
      isArchived: selectedFilters?.isArchived,
      form: selectedFilters?.form || [],
      createdAtStart: selectedFilters?.createdAtStart,
      createdAtEnd: selectedFilters?.createdAtEnd,
      daysInStage: selectedFilters?.daysInStage,
      groups: selectedFilters?.groups || []
    }

    $scope.flags.isSearching = true
    api._resetSearchFilterObject(false, true)
    api._getTasksSearchFilter().finally(() => {
      $scope.searchFilter.loading = false
    })
  }

  function _setHeader () {
    const rightButtons = []
    $scope.headerToolbar = {
      rightButtons,
      search: {
        onSearch: (searchTerm) => {
          search = searchTerm

          if (!searchTerm || searchTerm === '') {
            $scope.flags.isSearching = false
            $scope.searchFilter = {
              items: [],
              count: 0
            }
            search = undefined
            filters = null
            return
          }

          $scope.flags.isSearching = true
          api._resetSearchFilterObject(false, true)
          api._getTasksSearchFilter().finally(() => {
            $scope.searchFilter.loading = false
          })
        }
      },
      advancedFilter: {
        filters: WorkflowHeaderService.getAllTasksFilters($translate, $rootScope.oUser.locale, false),
        onFilter: api._onSearchFilter
      }
    }

    if ($rootScope.isUserSysAdminAdmin()) {
      rightButtons.push({
        type: 'button',
        btnType: 'secondary',
        label: $translate.instant('briefings'),
        icon: 'clipboard',
        onClick: api._goToBriefingsPage
      })
    }

    if ($rootScope.isUserSysAdminAdmin()) {
      rightButtons.push({
        type: 'button-new',
        btnType: 'secondary',
        label: $translate.instant('calendar'),
        icon: 'calendar',
        onClick: api._goToCalendarPage,
        isNew: true,
        isNewLabel: $translate.instant('new')
      })
    }

    rightButtons.push({
      type: 'dropdown',
      btnType: 'primary',
      label: $translate.instant('createNew'),
      icon: 'plus',
      options: [
        {
          icon: 'tasks',
          label: $translate.instant('task'),
          onClick: api._openCreateTaskDialog
        }
      ]
    })

    if ($rootScope.isUserSysAdminAdmin()) {
      rightButtons[rightButtons.length - 1].options.push({
        divider: true
      },
      {
        icon: 'grid',
        label: $translate.instant('board'),
        onClick: api._addNewBoard
      })
    }
  }
}

export { HomeController }
